import React from 'react';
import { Grid, Typography, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import AssessmentIcon from '@mui/icons-material/Assessment';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IDatesChipProps {
    filterNames: string[],
    onSelect: (filterName: string, value: any) => void,
    show: boolean,
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterLabel: string;
    currentStartDateFilter?: Date;
    showOnReport?: boolean;
}

class DatesChip extends React.Component<IDatesChipProps, {}> {
    constructor(props) {
        super(props);
    }


    public handleSelect = (name: any, value: any) => {
        this.props.onSelect(name, value);
    }

    private handleDelete = () => {
        if (this.props.removeFilter) {
            this.props.removeFilter(this.props.filterFlag, this.props.filterNames);
        }
    }

    public render() {
        const classes = styles;

        const showRemove = this.props.removeFilter !== null && this.props.removeFilter !== undefined ?
            <IconButton title="Remove" aria-label="Remove" onClick={this.handleDelete} sx={classes.button}><CancelIcon /></IconButton> : <React.Fragment />;

        return (
            <>
                {this.props.show &&
                    <Grid>
                        <Grid container sx={classes.root} justifyContent="space-between" alignItems="center">
                            {this.props.showOnReport &&
                                <AssessmentIcon sx={{ ml: 1 }} />
                            }
                            <Grid sx={classes.text}>
                                <Typography variant="body1">{this.props.filterLabel}</Typography>
                            </Grid>
                            <Grid>
                                {showRemove}
                            </Grid>
                        </Grid>
                    </Grid>

                }
            </>
        )
    }
}
export default DatesChip;